import PaymentsIcon from "@mui/icons-material/Payments";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CampaignIcon from "@mui/icons-material/Campaign";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { formatDate } from "./DateFormat";

// -----------------------------------------------------------------------------
// Type -> icon + accent color lookup.
//
// `type` is a fixed backend enum (10 CONFIRMED values, Notification/type.ts).
// Any unknown type falls back to a neutral bell so the UI never breaks.
// -----------------------------------------------------------------------------
export const TYPE_META = {
  subscription_expiring: { icon: HourglassBottomIcon, color: "#ed6c02", label: "Subscription expiring" },
  subscription_expired: { icon: WarningAmberIcon, color: "#d32f2f", label: "Subscription expired" },
  subscription_renewed: { icon: AutorenewIcon, color: "#2e7d32", label: "Subscription renewed" },
  payment_successful: { icon: PaymentsIcon, color: "#2e7d32", label: "Payment successful" },
  payment_failed: { icon: ErrorOutlineIcon, color: "#d32f2f", label: "Payment failed" },
  plan_upgraded: { icon: UpgradeIcon, color: "#2e7d32", label: "Plan upgraded" },
  plan_downgraded: { icon: TrendingDownIcon, color: "#ed6c02", label: "Plan downgraded" },
  account_disabled: { icon: BlockIcon, color: "#d32f2f", label: "Account disabled" },
  account_reenabled: { icon: LockOpenIcon, color: "#2e7d32", label: "Account re-enabled" },
  manual: { icon: CampaignIcon, color: "#1976d2", label: "Announcement" },
};

const DEFAULT_TYPE_META = {
  icon: NotificationsIcon,
  color: "#607d8b",
  label: "Notification",
};

export const getTypeMeta = (type) =>
  TYPE_META[String(type || "").toLowerCase()] || DEFAULT_TYPE_META;

// -----------------------------------------------------------------------------
// Priority -> accent (Notification/type.ts). critical/high stand out; normal
// and low are quiet.
// -----------------------------------------------------------------------------
export const PRIORITY_META = {
  critical: { color: "#d32f2f", label: "Critical" },
  high: { color: "#ed6c02", label: "High" },
  normal: { color: "#1976d2", label: "Normal" },
  low: { color: "#9e9e9e", label: "Low" },
};

export const getPriorityMeta = (priority) =>
  PRIORITY_META[String(priority || "").toLowerCase()] || null;

// -----------------------------------------------------------------------------
// Relative "time ago" for createdAt.
// -----------------------------------------------------------------------------
export const relativeTime = (value) => {
  if (!value) return "";
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Math.max(0, Date.now() - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  const w = Math.floor(d / 7);
  if (w < 5) return `${w}w ago`;
  return formatDate(value);
};
